var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 135,
    viewBox: "0 0 151 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9947 42.5768C38.2567 66.8609 33.9281 95.0333 59.4349 119.024C79.5616 137.952 114.264 131.814 135.026 107.53C155.764 83.2459 155.569 49.033 134.561 31.0828C113.579 13.1571 79.7573 18.2927 58.9947 42.5768Z",
    fill: "#991740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7161 38.8353C35.2226 62.8014 35.6383 96.7942 56.6209 114.72C77.628 132.646 111.254 127.755 131.723 103.764C152.217 79.7978 151.801 45.805 130.818 27.8793C109.811 9.95358 76.2096 14.8446 55.7161 38.8353Z",
    fill: "#FF1C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3167 43.6286C43.8557 64.0488 44.198 93.0283 62.0993 108.313C80.0005 123.597 108.662 119.415 126.123 98.9709C143.584 78.5507 143.242 49.5713 125.341 34.2867C107.439 19.0022 78.7778 23.184 61.3167 43.6286Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4759 48.0306C51.8027 65.2226 52.0962 89.5556 67.1362 102.419C82.1761 115.258 106.289 111.761 120.962 94.5689C135.635 77.3769 135.342 53.0439 120.302 40.1804C105.262 27.317 81.1735 30.8385 66.4759 48.0306Z",
    fill: "#FF1C4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.834 52.6032C60.0466 66.4204 60.2911 85.9602 72.372 96.2803C84.4529 106.625 103.822 103.788 115.609 89.9953C127.396 76.1781 127.152 56.6383 115.071 46.3182C102.99 35.9736 83.6459 38.8105 71.834 52.6032Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2633 57.225C68.386 67.6185 68.5572 82.3406 77.6546 90.1174C86.7519 97.8697 101.327 95.7421 110.18 85.3731C119.057 74.9796 118.886 60.2575 109.789 52.4807C100.691 44.7284 86.1406 46.856 77.2633 57.225Z",
    fill: "#FF1C4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7413 61.9205C76.8232 68.8413 76.9454 78.6724 83.0103 83.8324C89.0752 89.0169 98.784 87.5985 104.702 80.6777C110.62 73.7569 110.498 63.9258 104.433 58.7658C98.3682 53.5813 88.6595 54.9997 82.7413 61.9205Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9758 67.2279C86.408 70.2359 86.4569 74.4911 89.0736 76.741C91.7148 78.9664 95.9211 78.355 98.4889 75.3715C101.032 72.3635 100.983 68.1083 98.3666 65.8584C95.7254 63.6329 91.5191 64.2443 88.9758 67.2279Z",
    fill: "#FF1C4F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 19.3441C40.625 19.3441 35.0003 0 32.0901 0C29.1799 0 27.9816 6.5051 27.9816 6.5051L40.625 19.3441Z",
    fill: "#FFA523"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 19.8328C40.1367 19.8328 20.7926 14.2081 20.7926 11.2979C20.7926 8.38776 27.2977 7.18945 27.2977 7.18945L40.1367 19.8328Z",
    fill: "#FFA523"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4694 6.82227L93.7188 71.2863",
    stroke: "#004A67",
    strokeWidth: 4.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6289 46.7099C23.6289 46.7099 10.3252 31.5721 7.70854 32.7949C5.06737 34.0421 6.73033 40.4249 6.73033 40.4249L23.6289 46.7099Z",
    fill: "#0070C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3867 47.3695C23.3867 47.3695 3.48014 50.4509 2.25738 47.8342C1.01016 45.193 6.39031 41.3535 6.39031 41.3535L23.3867 47.3695Z",
    fill: "#0070C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.389 40.9395L93.7188 71.2884",
    stroke: "#004A67",
    strokeWidth: 4.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1836 87.2818C21.1836 87.2818 1.91285 81.4125 0.323259 83.8336C-1.26633 86.2791 3.50244 90.8278 3.50244 90.8278L21.1836 87.2818Z",
    fill: "#61CECB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 87.9648C21.3047 87.9648 6.02015 101.073 3.57462 99.4833C1.15355 97.8937 3.6969 91.8043 3.6969 91.8043L21.3047 87.9648Z",
    fill: "#61CECB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47884 91.4383L93.7188 71.2871",
    stroke: "#004A67",
    strokeWidth: 4.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7578 116.506C34.7578 116.506 14.8268 119.343 14.411 122.204C13.9953 125.09 20.2558 127.193 20.2558 127.193L34.7578 116.506Z",
    fill: "#A353EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1953 117.066C35.1953 117.066 26.8805 135.408 23.9948 134.992C21.1335 134.601 20.8645 127.998 20.8645 127.998L35.1953 117.066Z",
    fill: "#A353EA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4997 127.754L93.7188 71.2871",
    stroke: "#004A67",
    strokeWidth: 4.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.4578f11cdb1bca3ac9ae7606320ddfef.svg";
export { ForwardRef as ReactComponent };